export default __webpack_public_path__ + "static/media/vpp.23b5959d.png";